<template>
  <div class="AddDistributor">
    <t-card title="添加经销商" bordered>
      <t-form
        ref="formRef"
        :data="form"
        :rules="rules"
        label-width="120px"
        @submit="onSubmit"
        @reset="onReset"
      >
        <t-form-item label="用户名" name="username">
          <t-input
            v-model="form.username"
            placeholder="请输入用户名"
            clearable
          />
        </t-form-item>

        <t-form-item label="密码" name="password">
          <t-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            clearable
          />
        </t-form-item>

        <t-form-item label="账号权限" name="owner">
          <t-select
            v-model="form.owner"
            placeholder="请选择权限"
            clearable
          >
            <t-option label="超级管理员" :value="0" />
            <t-option label="经销商" :value="1" />
          </t-select>
        </t-form-item>

        <t-form-item label="可用制卡次数" name="balance">
          <t-input
            v-model="form.balance"
            placeholder="请输入可用制卡次数"
            clearable
          />
        </t-form-item>

        <t-form-item label="可用赠卡次数" name="balanceZS">
          <t-input
            v-model="form.balanceZS"
            placeholder="请输入可用赠卡次数"
            clearable
          />
        </t-form-item>

        <t-form-item label="直属上级" name="promiss">
          <t-input
            v-model="form.promiss"
            placeholder="请输入直属上级账号（没有请写无）"
            clearable
          />
        </t-form-item>

        <t-form-item label="备注项" name="bindQQ">
          <t-input
            v-model="form.bindQQ"
            placeholder="请输入备注"
            clearable
          />
        </t-form-item>

        <t-form-item label="绑定手机" name="bindPhone">
          <t-input
            v-model="form.bindPhone"
            placeholder="请输入绑定手机"
            clearable
          />
        </t-form-item>

        <t-form-item label="关联淘宝店" name="TaobaoShop">
          <t-input
            v-model="form.TaobaoShop"
            placeholder="请输入关联淘宝店"
            clearable
          />
        </t-form-item>

        <t-form-item>
          <t-space>
            <t-button theme="primary" type="submit">
              提交
            </t-button>

            <t-button theme="default" type="reset">
              重置
            </t-button>
          </t-space>
        </t-form-item>
      </t-form>
    </t-card>
  </div>
</template>

<script>
import axios from '../axios';
import { MessagePlugin } from 'tdesign-vue-next';

export default {
  name: 'AddDistributor',

  data() {
    return {
      form: {
        username: '',
        password: '',
        owner: '',
        balance: '',
        balanceZS: '',
        promiss: '',
        bindQQ: '',
        bindPhone: '',
        TaobaoShop: ''
      },

      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            type: 'error'
          },
          {
            validator: (val) => {
              if (!val) return false;
              return val.length >= 3 && val.length <= 30;
            },
            message: '用户名长度应在 3 到 30 个字符之间',
            type: 'error'
          }
        ],

        password: [
          {
            required: true,
            message: '请输入密码',
            type: 'error'
          },
          {
            validator: (val) => {
              if (!val) return false;
              return val.length >= 6;
            },
            message: '密码至少 6 位',
            type: 'error'
          }
        ],

        owner: [
          {
            required: true,
            message: '请选择账号权限',
            type: 'error'
          }
        ],

        balance: [
          {
            required: true,
            message: '请输入可用制卡次数',
            type: 'error'
          }
        ],

        balanceZS: [
          {
            required: true,
            message: '请输入可用赠卡次数',
            type: 'error'
          }
        ]
      }
    };
  },

  methods: {
    async onSubmit({ validateResult, firstError, e }) {
      if (e) {
        e.preventDefault();
      }

      if (validateResult !== true) {
        MessagePlugin.error(firstError || '请检查表单填写内容');
        return;
      }

      try {
        const token = localStorage.getItem('user-token');

        const response = await axios.post('/index.php?action=addDistributor', {
          token,
          username: this.form.username,
          password: this.form.password,
          owner: this.form.owner,
          balance: this.form.balance,
          balanceZS: this.form.balanceZS,
          promiss: this.form.promiss,
          bindQQ: this.form.bindQQ || '',
          bindPhone: this.form.bindPhone || '',
          TaobaoShop: this.form.TaobaoShop || '',
          createNum: '0'
        });

        if (response.data.success) {
          MessagePlugin.success('经销商注册成功');
          this.onReset();
        } else {
          MessagePlugin.error(response.data.message || '注册失败');
        }
      } catch (error) {
        console.error('Error adding distributor:', error);
        MessagePlugin.error('注册失败，请稍后重试');
      }
    },

    onReset() {
      this.form = {
        username: '',
        password: '',
        owner: '',
        balance: '',
        balanceZS: '',
        promiss: '',
        bindQQ: '',
        bindPhone: '',
        TaobaoShop: ''
      };

      this.$nextTick(() => {
        if (this.$refs.formRef && this.$refs.formRef.clearValidate) {
          this.$refs.formRef.clearValidate();
        }
      });
    }
  }
};
</script>

<style scoped>
.AddDistributor {
  padding: 20px;
}

.AddDistributor :deep(.t-card) {
  max-width: 760px;
}

.AddDistributor :deep(.t-select),
.AddDistributor :deep(.t-input) {
  width: 100%;
}
</style>